import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {BaseClass} from 'src/app/shared/classes/base';
import {ProcessConfig} from 'src/app/shared/interfaces/process-config.interface';
import {AggregatedAreaConfig} from 'src/app/360-evaluation/_interfaces/area-config.interface';
import {HeadEvaluated} from 'src/app/head-evaluation/_interfaces/head-evaluated.interface';
import {TranslationService} from 'src/app/shared/services/translation.service';

@Component({
    selector: 'app-evaluated-user-list',
    templateUrl: './evaluated-user-list.component.html',
    styleUrls: ['./evaluated-user-list.component.scss'],
})
export class EvaluatedUserListComponent extends BaseClass implements OnInit, OnChanges {
    @Input() public processConfig: ProcessConfig = null;
    @Input() cycleParticipantId: number = null;
    @Input() public displayedUserEvaluations: Array<HeadEvaluated> = [];
    @Input() public areas: AggregatedAreaConfig[] = [];
    @Input() public cycleId: number = null;
    @Output() getEvaluations = new EventEmitter<string>();

    public colSizeToAreas: number = 6.5;
    public colSize: number = null;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['areas'] && this.areas.length > 0) {
            this.colSize = this.colSizeToAreas / (2 + this.areas.length);
        }
    }
}